import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { SetComponentId } from "../../redux/counterSlice";
import { getStartOfMonth } from "./SalesDashBoard";
import API from "../../services/api";
import Datepicker from "react-tailwindcss-datepicker";
import Select from "react-select";
import ScrollContainer from "react-indiana-drag-scroll";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import sundayIcon from "../../assets/images/sunday.svg";
import closeSvg from "../../assets/images/uncheck.svg";
import filterSvg from "../../assets/images/filter.svg";
import { SlDrawer, SlIcon, SlButton, SlTooltip } from "@shoelace-style/shoelace/dist/react";
import directMeetIcon from "../../assets/images/directMeeting.svg";
import virtMeetIcon from "../../assets/images/virtMeeting.svg";
import emailIcon from "../../assets/images/email.svg";
import whatsappIcon from "../../assets/images/whatsappIcon.svg";
import phoneIcon from "../../assets/images/phone.svg";
import InteractionHistory from "./InteractionHistory";
import { alphabets, BrandsTypes, InteractionType } from "../../utils/constants";
import { Toast } from "../../shared/Toast";

function TeamManagement() {
  const dispatch = useDispatch();
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const allowedNewUserTypes = [...new Set(salesUsersList.map(item => item.new_user_type))]
  const [tempSalesUsersList, setTempSalesUsersList] = useState(salesUsersList)
  dispatch(SetComponentId(45));
  const get7DaysBack = () => {
    let date = new Date();
    let startDate = new Date(date);
    startDate.setDate(date.getDate() - 7);
    return startDate;
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const [date, setDate] = useState({
    startDate: get7DaysBack(),
    endDate: new Date(),
  });
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [initialRender, setIntialRender] = useState(true);
  const [selectedList, setSelectedList] = useState([]);
  const [dateHeaders, setDateHeaders] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [history, setHistory] = useState(false)
  const [histBrand, setHistBrand] = useState({})
  const [filterActiveLetters, setFilterActiveLetters] = useState([...new Set(
        salesUsersList.map((item) =>{
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )]);
  const [searchFilter, setSearchFilter] = useState('')
const [showUsersFilter, setShowUsersFilter] = useState( false
    // JSON.parse(localStorage.getItem("selectedSalesList"))?.length ? false : salesUsersList?.length > 1 ?  true : false
  )
  const [newUserTypeInfilter, setNewUserTypeInfilter] = useState(0)
  const handleValueChange = (newValue) => {
    setDate(newValue);
  };
  const getData = async (sales_person_ids) => {
    try {
      setLoader(true);
      let reqObj = {
        date,
        sales_person_ids,
      };
      let res = await API({
        url: "/teamManagement/get",
        method: "POST",
        responseType: "json",
        data: reqObj,
      });
      if (res.code === 200) {
        setData(res.data);
      }
      setLoader(false);
      setIntialRender(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const getDatesInRange = ({ startDate, endDate }) => {
    const dates = [];
    let currentDate = new Date(startDate);
    currentDate.setHours(0, 0, 0, 0);
    while (currentDate <= new Date(endDate)) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates.reverse();
  };

  useEffect(() => {
    setSelectedList(salesUsersList);
    localStorage.setItem("selectedSalesList", JSON.stringify(salesUsersList.map(item => item.value)))
    getData(salesUsersList.map((item) => item.value));
    setDateHeaders(getDatesInRange(date));
  }, []);
  useEffect(() => {
    if (date.startDate !== null && date.endDate !== null && !initialRender) {
      getData(selectedList.map(item => item.value));
      setDateHeaders(getDatesInRange(date));
    }
  }, [date, selectedList]);

  const scrollToSection = (id) => {
    document?.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const handleNewUsrTypChange = (new_user_type) => {
    try {
      setNewUserTypeInfilter(new_user_type)
      let filteredArray = salesUsersList
      if(searchFilter){
        filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(searchFilter))
      }
      if(+new_user_type){
        filteredArray = filteredArray.filter(item => +item.new_user_type === +new_user_type)
      }
      setTempSalesUsersList(filteredArray)
      setFilterActiveLetters([...new Set(
        filteredArray.map((item) => {
          return item?.label[0]?.toUpperCase()
        }
        ).sort()
      )])
    } catch (error) {
      console.error("Error @ handleNewUsrTypChange", error)
    }
  }

  const downloadData = () => {
    try {

      const workbook = XLSX.utils.book_new(); // Create a new workbook
      let headers = ['SalesPerson', ...dateHeaders.map(ditem => ditem.toDateString())]
      let rows = []
      data.map(item => {
        let row = [item.name]
        {dateHeaders.map((date) => {
          let firstTimeStamp = Math.round(
            new Date(date) / 1000
          );
          let endDatetime = new Date(date);
          endDatetime.setHours(23, 59, 59, 999);
          let endTimeStamp = Math.floor(
            new Date(endDatetime) / 1000
          );
          let dateFilteredInteracts =
            item.interactions.filter(
              (intItem) =>
                firstTimeStamp <= intItem.date &&
                intItem.date <= endTimeStamp
            );
          if (dateFilteredInteracts.length) {
            dateFilteredInteracts =
              dateFilteredInteracts.sort(
                (a, b) => a.date - b.date
              );
          }
          if(dateFilteredInteracts.length === 0){
            row.push('Empty')
          }
          row.push(dateFilteredInteracts.map(
            (intitem) => 
              `${intitem.brand_name} (${InteractionType[intitem.type]})`
          ).join(` , \n`)       
        );
        })}
        rows.push(row)
      })
      console.log([headers, rows])
        // Convert to sheet and add to workbook
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "TeamManagement"
        );

      // Trigger download
      const fileName = `TeamManagement.xlsx`;
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });
      const excelBlob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(excelBlob, fileName);

    } catch (error) {
      console.error("Error downloadData:", error);
    }
  }

  return (
    <>
      <div className="d-flex justify-end my-2 ml-auto gap-2 items-center h-[5%]">
        <aside className="flex items-center gap-3 justify-center">
          <div className="border rounded-lg min-w-fit h-45 ">
            <Datepicker
              classNames="form-input"
              value={date}
              readOnly
              primaryColor={"cyan"}
              showShortcuts={true}
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleValueChange}
            />
          </div>
          {salesUsersList?.length > 1 ? <div className="select-sales-users ml-auto" onClick={() => { setShowUsersFilter(true) }}>
            Select Users
          </div> : null}
          {selectedList.length < salesUsersList.length ? 
          <div>
            <SlButton variant="neutral" onClick={() => {
                    setSelectedList(salesUsersList)
                  }}>All</SlButton>
          </div>: null}
          <sl-tooltip content="Download">
            <SlIcon
              library="lucide"
              name="download"
              className="hover:cursor-pointer hover:text-sky-400 transition-all ease-in-out"
              onClick={() => downloadData()}
            ></SlIcon>
          </sl-tooltip>
        </aside>
        {/* <img
          src={filterSvg}
          className="mobileOnly w-6 "
          onClick={() => setShowFilter(true)}
          alt="filter"
        ></img> */}
      </div>
      <div className="teamManagement">
          <table className="table table-bordered">
            <thead>
              <tr className=" stickyTop">
                <th className="stickyLeft header">Sales Person</th>
                {dateHeaders.map((item) => (
                  <th>{item.toDateString()}</th>
                ))}
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data?.map((item, index) => {
                  return (
                    <>
                      <tr>
                        <td className="stickyLeft" title={item.name}>{item.name}</td>
                        {dateHeaders.map((date) => {
                          let firstTimeStamp = Math.round(
                            new Date(date) / 1000
                          );
                          let endDatetime = new Date(date);
                          endDatetime.setHours(23, 59, 59, 999);
                          let endTimeStamp = Math.floor(
                            new Date(endDatetime) / 1000
                          );
                          let dateFilteredInteracts =
                            item.interactions.filter(
                              (intItem) =>
                                firstTimeStamp <= intItem.date &&
                                intItem.date <= endTimeStamp
                            );
                          if (dateFilteredInteracts.length) {
                            dateFilteredInteracts =
                              dateFilteredInteracts.sort(
                                (a, b) => a.date - b.date
                              );
                          }
                          return (
                            <>
                              {
                                <td>
                                  {
                                    <div className="d-flex flex-col gap-2">
                                      {dateFilteredInteracts.map(
                                        (intitem) => {
                                          return (
                                            <div className="d-flex font-light gap-2  items-center pointer">
                                              <SlTooltip
                                                content={
                                                  +intitem.type === 1
                                                    ? "Direct Meeting"
                                                    : +intitem.type === 2
                                                    ? "Virtual Meeting"
                                                    : +intitem.type === 3
                                                    ? "Call"
                                                    : +intitem.type === 4
                                                    ? "WhatsApp"
                                                    : +intitem.type === 5
                                                    ? "Email"
                                                    : ""
                                                }
                                              >
                                                <div>
                                                  {+intitem.type === 1 ? (
                                                    <img
                                                      src={directMeetIcon}
                                                      alt=""
                                                    />
                                                  ) : +intitem.type === 2 ? (
                                                    <img
                                                      src={virtMeetIcon}
                                                      alt=""
                                                    />
                                                  ) : +intitem.type === 3 ? (
                                                    <img
                                                      className="icoPhone"
                                                      src={phoneIcon}
                                                      alt=""
                                                    />
                                                  ) : +intitem.type === 4 ? (
                                                    <img
                                                      className="icoWhatsapp"
                                                      src={whatsappIcon}
                                                      alt=""
                                                    />
                                                  ) : +intitem.type === 5 ? (
                                                    <img
                                                      className="icoEmail"
                                                      src={emailIcon}
                                                      alt=""
                                                    />
                                                  ) : null}
                                                </div>
                                              </SlTooltip>
                                                <span data-toggle="tooltip" data-placement="top" title={intitem.description} onClick={()=> {  
                                                  setHistory(true);
                                                  setHistBrand({
                                                    name: intitem.brand_name,
                                                    brand_id: intitem.brand_id,
                                                    sales_person_id: intitem.sales_person_id
                                                  });
                                                  }}>
                                                  {intitem.brand_name}
                                                </span>
                                                {intitem.head_name ? <span>
                                                <SlTooltip content={intitem.head_name}>
                                                  <SlIcon library="lucide" className=" w-4 h-4 text-purple-600 " name="tag"></SlIcon>
                                                </SlTooltip>
                                                </span> : null}
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  }
                                  {dateFilteredInteracts.length === 0 ? (
                                    <div className="d-flex justify-center">
                                      <img src={sundayIcon} alt="" />
                                    </div>
                                  ) : null}
                                </td>
                              }
                            </>
                          );
                        })}
                      </tr>
                    </>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="15" />
            ) : (
              <TableLoader colspan="15" />
            )}
          </table>
      </div>
      {/* <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex items-center gap-3 flex-wrap justify-between">
            {
              <aside className="flex items-center gap-3 justify-center  flex-wrap ">
                <div className="z-10">
                  <Select
                    className="w-full"
                    placeholder="Select User"
                    size="medium"
                    value={salesUsersList.filter(
                      (option) => selectedList.indexOf(option.value) >= 0
                    )}
                    onChange={(selected) => {
                      setSelectedList(
                        selected ? selected.map((item) => item.value) : []
                      );
                    }}
                    options={salesUsersList}
                    isMulti
                  />
                </div>

                <div className="border rounded-lg min-w-fit h-45 ">
                  <Datepicker
                    classNames="form-input"
                    value={date}
                    readOnly
                    primaryColor={"cyan"}
                    showShortcuts={true}
                    // useRange={false}
                    configs={{
                      shortcuts: {
                        today: "today",
                        yesterday: "yesterday",
                        currentMonth: "currentMonth",
                        pastMonth: "lastMonth",
                      },
                    }}
                    onChange={handleValueChange}
                  />
                </div>
              </aside>
            }
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer> */}
      <div>
      {history && (<InteractionHistory show={history} setShow={setHistory} brand={histBrand} brandOptions={[{label: histBrand.name, value: histBrand.brand_id}]} ></InteractionHistory>)}
      </div>
      {showUsersFilter ? <div className="usersMultiSelect" onClick={() => { if (selectedList.length === 0) { Toast("error", "Select Atleast a User") } else { setShowUsersFilter(false) } }}>
        <div class="popupuserlist" onClick={(e) => e.stopPropagation()}>
          <div class="userlist-header">
            <div class="alphabiticals">
              <ul>
                {alphabets.map(alphabet => {
                  return <li
                    onClick={() => scrollToSection(alphabet)}
                    className={`${filterActiveLetters.includes(alphabet) ? "" : "inactive"
                      }`}

                  >
                    {alphabet}
                  </li>
                })}

              </ul>
            </div>
            <ul class="new-user-type">
              <li key={0} onClick={() => { handleNewUsrTypChange(0) }}>
                <label className={+newUserTypeInfilter === 0 ? 'active' : ''} onClick={() => handleNewUsrTypChange(0)}>
                  All
                </label>
              </li>
              {BrandsTypes.filter(item => allowedNewUserTypes.includes(item.value)).map((item) => (
                <li key={item.value} onClick={() => { handleNewUsrTypChange(item.value) }}>
                  <label className={+newUserTypeInfilter === item.value ? 'active' : ''} onClick={() => handleNewUsrTypChange(item.value)}>
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
            <div class="searchbox">
              <input class="form-control" placeholder="search" value={searchFilter} onChange={(e) => {
                setSearchFilter(e.target.value)
                let tempString = e.target.value.toLowerCase()
                let filteredArray = salesUsersList
                if (newUserTypeInfilter) {
                  filteredArray = filteredArray.filter(item => item.new_user_type === newUserTypeInfilter)
                }
                if (tempString) {
                  filteredArray = filteredArray.filter(item => item.label.toLowerCase().includes(tempString))
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    filteredArray.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
                else {
                  setTempSalesUsersList(filteredArray)
                  setFilterActiveLetters([...new Set(
                    salesUsersList.map((item) => {
                      return item?.label[0]?.toUpperCase()
                    }
                    ).sort()
                  )])
                }
              }}
              />
            </div>
          </div>

          <div class="userlistbody">
            {filterActiveLetters.map(alphabet => {
              let filteredUsers = tempSalesUsersList.filter(item => item.label[0].toUpperCase() === alphabet)
              return (<div class="alphabiticalletterelement">
                <div class="alphabiticalletter" id={alphabet}>
                  <span>{alphabet}</span>
                </div>

                <div class="userlist">
                  <ul>
                    {filteredUsers.map(user =>
                      <li onClick={() => { if (!selectedList.find(item => item.value === user.value)) { setSelectedList([...selectedList, user]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.map(item => item.value), user.value])) } else { setSelectedList([...selectedList.filter(item => item.value !== user.value)]); localStorage.setItem("selectedSalesList", JSON.stringify([...selectedList.filter(item => item.value !== user.value)].map(item => item.value))) } }} className={selectedList.find(item => item.value === user.value) ? "active" : ""}>
                        {user.label}
                      </li>)}
                  </ul>
                </div>
              </div>)

            }
            )}
          </div>

          <div class="userlistfooter">
            <div class="btnuserdetails">
              <button class="selectall" type="button" onClick={() => { setSelectedList([]); localStorage.setItem('selectedSalesList', JSON.stringify([])) }}>Clear All</button>
              <button class="selectonebyone" type="button" onClick={() => { setSelectedList([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))]); localStorage.setItem("selectedSalesList", JSON.stringify([...new Set(salesUsersList.filter(item => [...selectedList.map(item => item.value), ...tempSalesUsersList.map(item => item.value)].includes(item.value)))].map(item => item.value))) }}>Select All</button>
              <button class={`selectonebyone ${selectedList.length === 0 ? 'disabled' : ''}`} type="button" title={selectedList.length === 0 ? 'Select Atleast a User' : ''} onClick={() => { if (selectedList.length === 0) { Toast("error", "Select Atleast a User") } else { setShowUsersFilter(false) } }}>Apply</button>
            </div>
          </div>
          <button
            className="close-btn"
            onClick={() => { if (selectedList.length === 0) { Toast("error", "Select Atleast a User") } else { setShowUsersFilter(false) } }}
          >
            <img src={closeSvg} alt="close2" />
          </button>
        </div>
      </div> : null}
    </>
  );
}

export default TeamManagement;
